import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import Tappable from 'react-tappable'

import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import Image from 'components/image'
import HeartRating from 'components/heart-rating'
import PriceDisplay from '../price-display'
import css from './preview-bar.scss'

const PreviewBar = ({
  availabilityMessage,
  brand,
  imageUrl,
  isElectronicGiftCard,
  name,
  onClick,
  price,
  rating,
  reviewCount,
  showReviews,
  showPrice,
  show,
}) => {
  const [microUtilityEnabled, setMicroUtilityEnabled] = useState(false)
  const [currentUser] = useCurrentUser()

  // on mount pick up the currentUser
  useEffect(() => {
    setMicroUtilityEnabled(!currentUser)
  }, [currentUser])

  return (
    <CSSTransition
      classNames={{
        appear: css.appear,
        appearActive: css.appearActive,
        enter: css.enter,
        enterActive: css.enterActive,
        exit: css.leave,
        exitActive: css.leaveActive,
      }}
      appear
      timeout={400}
    >
      {show ? (
        <Tappable
          onClick={onClick}
          className={classNames(css.previewBar, {
            [css.microUtilityEnabled]: microUtilityEnabled,
          })}
        >
          <div className="container">
            <Image role="presentation" className={css.image} src={imageUrl} />
            <Row>
              <Col sm={7} md={8}>
                <div className={classNames(css.leftContent, { mtm: !brand })}>
                  <p className="h1 mts mtl-sm mbn mbs-sm">
                    <span className={css.brand}>{brand}</span>
                    <span className={css.name}>{name}</span>
                  </p>
                  {showReviews && (
                    <HeartRating
                      className={css.heartRating}
                      rating={rating}
                      reviewCount={reviewCount}
                    />
                  )}
                  {showPrice && (
                    <div className="visible-xs h6 man">
                      <PriceDisplay
                        price={price}
                        isElectronicGiftCard={isElectronicGiftCard}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col sm={5} md={4} className="text-right mtl hidden-xs">
                {showPrice && (
                  <div className="h4 mtm mbs">
                    <PriceDisplay
                      price={price}
                      isElectronicGiftCard={isElectronicGiftCard}
                      priceClassName="h4 mtm mbs"
                    />
                  </div>
                )}
                <p className={classNames('h7 mvs text-bold')}>
                  {availabilityMessage}
                </p>
              </Col>
            </Row>
          </div>
        </Tappable>
      ) : (
        <span />
      )}
    </CSSTransition>
  )
}

PreviewBar.propTypes = {
  availabilityMessage: PropTypes.string,
  brand: PropTypes.string,
  imageUrl: PropTypes.string,
  isElectronicGiftCard: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.shape({
    msrp: PropTypes.number,
    current: PropTypes.number,
  }),
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  show: PropTypes.bool,
  showPrice: PropTypes.bool,
}

export default PreviewBar
